export { default } from 'mapbox-gl';
//# sourceMappingURL=mapboxgl.browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-map-gl/dist/esm/utils/mapboxgl.browser.js
// module id = 41
// module chunks = 0